import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

// news load more start
function chunkArray(array, size) {
    const chunkyArr = [];
    let index = 0;
    while (index < array.length) {
        chunkyArr.push(array.slice(index, size + index));
        index += size;
    }    
    return chunkyArr;
}
const newsCard = document.querySelectorAll(".news-card")
const itemsContainer = document.querySelector(".latest-news__row");
const button = document.querySelector(".theme-button--load-more");
const postsShown = 9;
let count = 0;

if(button) {
    fetch(`/wp-json/post/all-posts`)
    .then((response) => response.json())
    .then((data) => {        
        data.splice(0, postsShown);
        const newData = chunkArray(data, postsShown);
        const currentChunk = newData[count];
    
        if (count == newData.length) {
            button.classList.add('d-none');
        }
    });
    button.addEventListener("click", () => {
        button.classList.add('loading');
    
        fetch(`/wp-json/post/all-posts`)
        .then((response) => response.json())
        .then((data) => {        
            data.splice(0, postsShown);
            const newData = chunkArray(data, postsShown);
            const currentChunk = newData[count];
    
            if (count <= newData.length) {
                const items = [];
                currentChunk.forEach((key, index) => {
                    const permalink = currentChunk[index].permalink;
                    const image = currentChunk[index].image;
                    const date = currentChunk[index].date;
                    const title = currentChunk[index].title;
                    const article = `
                        <div class="col-12 col-lg-4">
                            <a href="${permalink}" class="news-card">
                                <div class="news-card__image-container">
                                    <img src="${image}" class="ratio-item news-card__image" alt="${title}";">
                                </div>
                                <div class="news-card__category-date">
                                    News | ${date}
                                </div>
                                <h3 class="news-card__title">${title}</h3>
                            </a>
                        </div>`
                    items.push(article);
                });
    
                itemsContainer.insertAdjacentHTML("beforeend", items.join(""));
                count++;
    
                // set button to disable
                if (count === newData.length) {
                    button.classList.add('d-none');
                }
            }
            button.classList.remove('loading');
        })
        .catch((err) => {
            console.log("Something went wrong!", err);
        });
    });
};
// news load more finish

function moreNewsSection() {
    const newsHighlight = new Swiper(".more-news__swiper", {
        modules: [ Pagination ],
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 450,
        // allowTouchMove: false,
        pagination: {
            el: ".more-news__pagination",
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        }
    });
}

function newsSectionResponsive() {
    const detailNews = document.querySelector('.detail-news');
    const header = document.querySelector('.more-news__header');
    const buttonWrapperMobile = document.querySelector('.more-news__button-wrapper-mobile');
    const button = document.querySelector('.more-news__button');

    if(detailNews) {
        if (window.innerWidth < 576) {
            buttonWrapperMobile.append(button);
        } else {
            header.append(button);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    moreNewsSection();
    newsSectionResponsive();
})

window.addEventListener('resize', () => {
    newsSectionResponsive();
})